import React from 'react'
import { getStockReports } from '@/api/stock'
import { Layout, Button, Tag, Empty } from 'antd'
import { DownloadOutlined } from '@ant-design/icons'
import { useEffect, useState } from 'react'
import type { StockReport, StockReportDetail } from '@/types/stockPool'
import { useFeedback } from '@/utils/antdApp'
import { getStockReportDetail } from '@/api/stock'
import Markdown from 'react-markdown'
import './index.scss'

const { Sider, Content } = Layout
const reportTabs = [
    {
        key: 1,
        value: '',
        label: '全部',
    },
    {
        key: 2,
        value: 'research',
        label: '研报',
    },
    {
        key: 3,
        value: 'annual,interim_h1,interim_h2',
        label: '年报',
    },
    {
        key: 4,
        value: 'quarterly_q1,quarterly_q2,quarterly_q3,quarterly_q4',
        label: '季报',
    },
]
export default function Reports({ stockCode, onReportClick, renderFooter }: {
    stockCode: string
    onReportClick: (report: StockReport) => void
    renderFooter?: (report: StockReportDetail | null) => React.ReactNode
}) {
    const [activeKey, setActiveKey] = useState(1)
    const [reports, setReports] = useState<StockReport[]>([])
    const [report, setReport] = useState<StockReportDetail | null>(null)
    const { message } = useFeedback()
    const changeTab = (key: number) => {
        setActiveKey(key)
    }
    useEffect(() => {
        if (!stockCode) return
        getStockReports({code: stockCode, report_type: reportTabs[activeKey - 1].value}).then((data) => {
            setReports(data.items ?? [])
        }).catch(() => {
            message.error('获取研报失败')
        })
    }, [activeKey, stockCode])

    const reportTypeMap = (type: string) => {
        return reportTabs.find((item) => item.value.includes(type))?.label
    }

    const getReportDetail = (id: number) => {
        getStockReportDetail({id}).then((data) => {
            setReport(data)
        }).catch(() => {
            message.error('获取研报详情失败')
        })
    }

    const handleReportClick = (report: StockReport) => {
        getReportDetail(report.id)
        onReportClick(report)
    }

    const handleDownload = (url: string) => {
        window.open(url, '_blank')
    }

    // 下载链接：优先 source_url（跳转查看），其次 pdf_url（流式下载），都为空则禁用
    const downloadUrl = report?.source_url || report?.pdf_url || null

    return (
        <Layout>
            <Sider className='reports-sider' width={256}>
                <div className='reports-sider-header color-3'>
                    <span className={`pool-layout-sider-content-tabs-item ${activeKey === 1 ? 'active' : ''}`} onClick={() => changeTab(1)}>全部</span>
                    <span className={`pool-layout-sider-content-tabs-item ${activeKey === 2 ? 'active' : ''}`} onClick={() => changeTab(2)}>研报</span>
                    <span className={`pool-layout-sider-content-tabs-item ${activeKey === 3 ? 'active' : ''}`} onClick={() => changeTab(3)}>年报</span>
                    <span className={`pool-layout-sider-content-tabs-item ${activeKey === 4 ? 'active' : ''}`} onClick={() => changeTab(4)}>季报</span>
                </div>
                <div className='reports-sider-content'>
                    {reports.map((item) => (
                        <div key={item.id} className={`reports-sider-content-item text-12 ${item.id === report?.id ? 'active' : ''}`} onClick={() => handleReportClick(item)}>
                            <Tag variant='filled' className='is-accent text-10'>{reportTypeMap(item.report_type)}</Tag>
                            <div className='reports-sider-content-item-title'>{item.title}</div>
                            <div className='reports-sider-content-item-date text-10 color-3'>发布日期：{item.published_date}</div>
                        </div>
                    ))}
                    {reports.length === 0 && (
                        <div className='reports-sider-content-empty'>
                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="暂无报表" />
                        </div>
                    )}
                </div>
            </Sider>
            <Content>
                <div className='reports-content'>
                    {
                        report ? (
                            <>
                                <div className='reports-content-header'>
                                    <div className='reports-content-header-tags flex items-center flex-between'>
                                        <Tag variant='filled' className='is-accent text-10'>{reportTypeMap(report.report_type)}</Tag>
                                        <Button icon={<DownloadOutlined /> } type='primary' disabled={!downloadUrl} onClick={() => downloadUrl && handleDownload(downloadUrl)} size="small" className='text-10'>下载</Button>
                                    </div>
                                    <div className='reports-content-header-title'>{report.title}</div>
                                </div>
                                <div className='reports-content-body'>
                                    <Markdown>{report.md_content}</Markdown>
                                    {renderFooter?.(report)}
                                </div>
</>
                        ):
                        <div className='reports-content-empty'>
                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="从左
                            侧选择一篇文档查看详情" />
                        </div>
                    }
                </div>
            </Content>
        </Layout>
    )
}